import useSiteConfigAuth from "../api/sanity/queries/getSiteConfigWithCode";
import useSiteConfigUnAuth from "../api/sanity/queries/getSiteConfigWithDomain";

function useGetColours() {
  const { data: siteConfig } = useSiteConfigAuth();
  const { data: domainConfig } = useSiteConfigUnAuth();

  const darkColour = siteConfig?.dark_colour ?? "#24201F";
  const highlightColour = siteConfig?.highlight_colour ?? "#EC542E";
  const statusSuccessColour = siteConfig?.status_colour_1_success ?? "#22c55e";
  const statusWarningColour = siteConfig?.status_colour_2_warning ?? "#fb923c";
  const statusErrorColour = siteConfig?.status_colour_3_error ?? "#ef4444";
  const highlightColour2 = siteConfig?.highlight_colour_2 ?? "#25BCBB";
  const onboardingDarkColour = domainConfig?.onboarding_dark_colour ?? "#24201F";
  const grad1Colour = domainConfig?.onboarding_background_colour_1 ?? "#24201F";
  const grad2Colour = domainConfig?.onboarding_background_colour_2 ?? "#24201F";
  const onboardingHighlightColour = domainConfig?.onboarding_highlight_colour ?? "#EC542E";
  const onboardingHighlightColour2 = domainConfig?.onboarding_highlight_colour_2 ?? "#25BCBB";

  return {
    darkColour,
    highlightColour,
    highlightColour2,
    statusSuccessColour,
    statusWarningColour,
    statusErrorColour,
    onboardingDarkColour,
    grad1Colour,
    grad2Colour,
    onboardingHighlightColour,
    onboardingHighlightColour2,
  };
}

export default useGetColours;
